import { styled } from 'styled-components';
import { tk, Skeleton } from '@sunwebgroup/ui-components';
import { Card } from './UserReview';

export const CardSkeleton = styled(Card)`
  width: 100%;
  height: 150px;
  box-shadow: none;
`;

const HeadingContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const BubbleSkeleton = styled(Skeleton)`
  padding: ${tk('spacing_2xs')} ${tk('spacing_sm')};
  background-color: ${tk('theme_color_neutral_300')};
  margin-right: ${tk('spacing_sm')};
  border-radius: ${tk('radius_extra_large')};
  height: 30px;
  width: 50px;
`;

export const LabelSkeleton = styled(Skeleton)`
  width: 100px;
  height: ${tk('typography_body_sm_bold_size')};
`;

const Rating = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
`;

const DateSkeleton = styled(Skeleton)`
  width: 100px;
  height: ${tk('typography_body_sm_bold_size')};
`;

const ContentSkeleton = styled(Skeleton)`
  height: ${tk('spacing_lg')};
  margin-top: ${tk('spacing_md')};
`;

const FooterSkeleton = styled(Skeleton)`
  width: 100px;
  height: ${tk('typography_body_sm_bold_size')};
  margin-top: ${tk('spacing_md')};
`;

export function UserReviewLoading() {
  return (
    <CardSkeleton>
      <HeadingContent>
        <Rating>
          <BubbleSkeleton />
          <LabelSkeleton />
        </Rating>
        <DateSkeleton />
      </HeadingContent>
      <ContentSkeleton />
      <FooterSkeleton />
    </CardSkeleton>
  );
}
